import { Location } from "gen/company/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { Transfer_Status as TransferStatus } from "gen/txn/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { QueryParams, WebUrl } from "shared-web/lib/webUrl"

import { encodeQueryParam } from "hooks/filters/useWebFilter"

import { cleanStatus } from "./cleanStatus"

const statusSegments: Record<TransferStatus, string> = {
  [TransferStatus.UNDEFINED]: "new",
  [TransferStatus.CREATED]: "drafts",
  [TransferStatus.REQUESTED]: "requested",
  [TransferStatus.SENT]: "sent",
  [TransferStatus.RECEIVED]: "received",
  [TransferStatus.VOIDED]: "voided",
}

export function transfers(
  status: TransferStatus = TransferStatus.UNDEFINED,
  location?: Pick<Location, "id" | "name">
): WebUrl {
  const pathname = `/pos/transfers/${statusSegments[status]}`

  if (!location) {
    return { pathname }
  }

  const key = status === TransferStatus.REQUESTED ? "from" : "to"
  const query: QueryParams = {
    [key]: encodeQueryParam(
      {
        key: UUID.idString(location.id),
        value: location.name,
      },
      true
    ),
  }

  return { pathname, query }
}

export function transfer(id?: PBUUID, status?: TransferStatus): WebUrl {
  const pathname = `/pos/transfers/${UUID.idString(id)}`

  const statusParam = transferStatusParam(status)
  if (!statusParam) {
    return { pathname }
  }

  return {
    pathname,
    query: { status: statusParam },
  }
}

export function transferStatusParam(status?: TransferStatus): string {
  if (!status) {
    return ""
  }
  return cleanStatus(TransferStatus[status])
}
